import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import PixelFormLayout from './containers/Form';
import PixelsGridLayout from './containers/Grid';

export default function PixelLayout() {
  return <Router>
    <PrivateRoute exact path="/path/pixels" component={PixelsGridLayout} />
    <PrivateRoute path={["/path/pixels/add", "/path/pixels/:id"]} component={PixelFormLayout} />
  </Router>
}
